<template>
    <div class="card card-height">
        <div class="table-responsive">
            <table class="table">
                <thead>
                    <tr>
                        <th>Client Name</th>
                        <th>Client ID</th>
                        <th>Bank-Branch</th>
                        <th>BDO</th>
                        <th>Sale Person</th>
                        <th>Location</th>
                        <th>Order Number</th>
                        <th>Order Type</th>
                        <th>Invoice no</th>
                        <th>Invoice Date</th>
                        <th>Base Amount</th>
                        <th>VAT Amount</th>
                        <th>Total Amount</th>
                        <th>Advance MR</th>
                        <th>Money Receipt Date</th>
                        <th>Money Receipt numbers</th>
                        <th>Receipt Amount</th>
                        <th>Refund Amount</th>
                        <th>AIT Deducted</th>
                        <th>VAT Deducted</th>
                        <th>Discount</th>
                        <th>Bed debt</th>
                        <th>Due</th>
                        <th>Action</th>
                    </tr>
                </thead>

                <tbody>
                    <tr v-for="(item, i) in tableItems" :key="i">
                        <td>{{ item.contact_name }}</td>
                        <td>{{ item.serial_no }}</td>
                        <td>{{ item.dealer_name }}</td>
                        <td>{{ item.sr_name }}</td>
                        <td>{{ item.sale_person_name }}</td>
                        <td>{{ item.area_name }}</td>
                        <td>{{ item.order_number }}</td>
                        <td>{{ item.order_type }}</td>
                        
                        <td>{{ item.bill_number }}</td>
                        <td>{{ item.date }}</td>
                        <td>{{ item.subtotal_amount }}</td>
                        <td>{{ item.vat_amount }}</td>
                        <td>{{ item.total_amount }}</td>

                        <td>0</td>
                        <td>{{ item.receipt_date }}</td>
                        <td>{{ item.receipt_no }}</td>
                        <td>{{ item.net_receipt_amount }}</td>
                        <td>{{ item.refund_amount }}</td>

                        <td>{{ item.ait_deducted }}</td>
                        <td>{{ item.vat_deducted }}</td>
                        <td>{{ item.discount }}</td>
                        <td>0</td>
                        <td>{{ getTotalDue(item) }}</td>

                        <td>
                            <div class="action">
                                <!-- Todo:: action -->
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        <p v-if="!tableItems.length" class="text-center mt-5">No data</p>
    </div>
</div>
</template>

<script setup>
const props = defineProps({
    tableItems: {
        type: Array,
    }
})

const getTotalDue = (item) => {
    return parseFloat(item.total_amount) - parseFloat(item.net_receipt_amount) - parseFloat(item.ait_deducted) - parseFloat(item.vat_deducted) - parseFloat(item.discount)
}
</script>

<style scoped>
.mr-5 {
    margin-right: 5px;
}
.action-th {
    width: 20%;
    text-align: center;
}
.name {
    width: 15%;
}
.action{
    text-align: center;
}

</style>